import ComponentName from '@Constant/componentName'
import { HOME_MARK } from '@Constant/behaviorTrack'

const home = [
  {
    component: () => import('../views/layout/Index.vue'),
    path: '/home',
    redirect: {
      name: ComponentName.home.index
    },
    children: [
      {
        component: () => import('../views/home/Index.vue'),
        path: 'index',
        name: ComponentName.home.index,
        auth: '*',
        meta: {
          title: '首页',
          logAuto: {
            pv: true,
            duration: true,
            source: HOME_MARK.PV
          }
        },
        children: [
          {
            path: 'finance',
            redirect: {
              name: ComponentName.home.index
            }
          },
          {
            component: () => import('../views/home/Message.vue'),
            path: 'message',
            name: ComponentName.home.message,
            // props: true,
            auth: '*',
            meta: {
              title: '消息通知'
            }
          }
        ]
      }
    ]
  }
]

export default home
